import { createFileRoute } from '@tanstack/react-router'
import { EditExamPage } from '_/features/pets/ui/pages/edit-exam-page'

const EditExamRoute = () => {
	const { petId, examId } = Route.useParams()
	return <EditExamPage petId={petId} examId={examId} />
}

export const Route = createFileRoute('/_authenticated/pets/$petId/exams/$examId/edit')({
	staticData: { title: 'exams_edit_title' },
	component: EditExamRoute,
})
